import { useState } from 'react';
import { TabType } from './consts';

export const useMyAccountTabs = () => {
  const [activeTab, setActiveTab] = useState<TabType>('reservations');

  return {
    activeTab,
    setActiveTab,
  };
};
